import { useTranslation } from 'react-i18next';
import type { ProductGroup } from '~/pages/rfq-view/itemGroups';
import { ProductLengthDetails } from './ProductLengthDetails';
import { SellerRowsTable } from './SellerRowsTable';
import type { ItemBlockData } from './splitAwardGridTypes';

export function ItemBlock({
  group,
  block,
  pickupPriceLabel,
  deliveryPriceLabel,
  selectedItemIds,
  onToggleItem,
  disabled,
}: Readonly<{
  group: ProductGroup;
  block: ItemBlockData;
  pickupPriceLabel: string;
  deliveryPriceLabel: string;
  selectedItemIds: Set<string>;
  onToggleItem: (itemId: string) => void;
  disabled: boolean;
}>) {
  const { t } = useTranslation('rfq-view');
  const { row, requestedBundles, offerings, lowestAmounts } = block;

  return (
    <div
      className="rounded-lg border border-neut-border bg-white p-4"
      data-testid={`item-block-${row.platformProductLengthId}`}
    >
      <h3 className="mb-2 flex flex-wrap items-baseline gap-x-2 text-sm font-semibold text-neut-prim">
        <ProductLengthDetails
          group={group}
          row={row}
          requestedBundles={requestedBundles}
        />
      </h3>
      {offerings.length === 0 ? (
        <p className="text-sm text-neut-sec italic">
          {t('rfq_view.no_seller_quoted_length')}
        </p>
      ) : (
        <SellerRowsTable
          row={row}
          offerings={offerings}
          pickupPriceLabel={pickupPriceLabel}
          deliveryPriceLabel={deliveryPriceLabel}
          requestedBundles={requestedBundles}
          lowestAmounts={lowestAmounts}
          selectedItemIds={selectedItemIds}
          onToggleItem={onToggleItem}
          disabled={disabled}
        />
      )}
    </div>
  );
}
